import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import ('@/layout/'),
      children:[
        {
          path: '',
          name: 'home',
          component: () => import ('@/pages/home'),
        },
        // {
        //   path: '/about',
        //   name: 'about',
        //   component: () => import ('@/pages/about'),
        // },
        // {
        //   path: '/connect',
        //   name: 'connect',
        //   component: () => import ('@/pages/connect'),
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js